import React from 'react'
import useSchoolSettings from '../../hooks/useSchoolSettings'
import { nameParts } from '../../admission/print/printFormat'
import '../../print.css'
import './careContract.css'

// หนังสือสัญญา — ยกข้อความมาจากแบบฟอร์มกระดาษของฝ่ายวิชาการทั้งฉบับ
// ครูประจำชั้นสั่งพิมพ์จากหน้าติดตามการดูแลนักเรียนได้เลย ช่องที่ระบบมีข้อมูล
// (ชื่อนักเรียน เลขประจำตัว ชั้น หอพัก) จะถูกเติมให้ ที่เหลือเป็นเส้นประ
// ให้เขียนด้วยมือเหมือนฟอร์มเดิม — ตั้งใจไม่บังคับให้กรอกครบก่อนพิมพ์

// ช่องกรอกหนึ่งช่อง — กว้างตามสัดส่วนที่เหลือของบรรทัด (ดู .cc-field ใน CSS)
const F = ({ value, grow = 1 }) => (
  <span className="cc-field" style={{ flexGrow: grow }}>{value || ''}</span>
)

export default function CareContractDoc({ info }) {
  const school = useSchoolSettings()
  const student = nameParts(info?.st_name)
  const schoolName = school.school_name

  return (
    <div className="cc-doc">
      <div className="cc-crest">
        <img src={school.logoSrc} alt="ตราโรงเรียน" />
      </div>
      <div className="cc-title">หนังสือสัญญา</div>

      <div className="cc-row">
        <span>ข้าพเจ้า นาย/นาง/นางสาว</span>
        <F value="" grow={1.3} />
        <span>นามสกุล</span>
        <F value="" />
        <span>เป็นผู้ปกครองของ</span>
      </div>
      <div className="cc-row">
        <span>นักเรียนชื่อ </span>
        <F value={student.prefixFirst} grow={1.3} />
        <span>นามสกุล</span>
        <F value={student.last} />
        <span>เลขประจำตัว</span>
        <F value={info?.st_idnumber} grow={0.8} />
      </div>
      <div className="cc-row">
        <span>ชั้นศาสนา</span>
        <F value={info?.islamic_class} />
        <span>ชั้นสามัญ</span>
        <F value={info?.class_room} />
        <span>หอพัก</span>
        <F value={info?.dorm_name} />
        <span>มีความสัมพันธ์</span>
        <F value={info?.guardian_relation} />
        <span>ซึ่งได้รับทราบ</span>
      </div>
      <p className="cc-p">
        พฤติกรรมของนักเรียนในปกครอง อันมีพฤติกรรมไม่เข้าเรียนตามหลักสูตรสถานศึกษาหรือการขาดเรียนเกินจำนวนโดย
        ไม่มีเหตุจำเป็น หรือมีพฤติกรรมไม่พึงประสงค์
      </p>

      <p className="cc-p cc-indent">
        ทางวิชาการ{schoolName} ได้ตักเตือนนักเรียนเป็นลำดับขั้นต้นแล้วนั้น แต่นักเรียนยังคงมีพฤติกรรมไม่เข้าเรียน
        หรือขาดเรียนโดยไม่มีเหตุจำเป็น หรือมีพฤติกรรมไม่พึงประสงค์ ทางโรงเรียนจึงมีความจำเป็นต้องเชิญผู้ปกครอง
        เพื่อรับทราบข้อมูลดังกล่าว
      </p>

      <p className="cc-p cc-indent">
        ด้วยเหตุนี้ทางโรงเรียนได้เชิญผู้ปกครองนักเรียนมารับทราบพร้อมหนังสือสัญญาแล้วนั้น หากนักเรียนยังคงมีพฤติกรรม
        ไม่เข้าเรียนหรือขาดเรียนโดยไม่มีเหตุจำเป็น หรือมีพฤติกรรมไม่พึงประสงค์ ทางโรงเรียนขอพิจารณาและตัดสิน
        นักเรียนดังต่อไปนี้
      </p>
      <p className="cc-list">1. นักเรียนถูกพักการเรียนตามเวลาที่โรงเรียนกำหนด</p>
      <p className="cc-list">2. นักเรียนมัธยมศึกษาปีที่ 3 และ 6 ไม่สามารถรายงานจบได้ตามชั้นปี</p>
      <p className="cc-list">3. นักเรียนพ้นสภาพ นักเรียน{schoolName}</p>

      <p className="cc-p cc-indent">
        หนังสือสัญญาฉบับนี้ได้ถูกยอมรับเมื่อมีการลงชื่อของนักเรียน ผู้ปกครองและผู้บริหาร{schoolName}เป็นต้นไป
      </p>

      <div className="cc-signs">
        <div>
          <div className="cc-row"><span>ลงชื่อ</span><F value="" /><span>นักเรียน</span></div>
          <div className="cc-row cc-sign-name"><span>(</span><F value={student.full} /><span>)</span></div>
        </div>
        <div>
          <div className="cc-row"><span>ลงชื่อ</span><F value="" /><span>ผู้ปกครอง</span></div>
          <div className="cc-row cc-sign-name"><span>(</span><F value="" /><span>)</span></div>
        </div>
      </div>

      <div className="cc-signs">
        <div>
          <div className="cc-row"><span>ลงชื่อ</span><F value="" /><span>หัวหน้าฝ่ายวิชาการ</span></div>
          <div className="cc-row cc-sign-name"><span>(</span><F value={school.academic_head_name} /><span>)</span></div>
        </div>
        <div>
          <div className="cc-row"><span>ลงชื่อ</span><F value="" /><span>ผู้อำนวยการ</span></div>
          <div className="cc-row cc-sign-name"><span>(</span><F value={school.principal_name} /><span>)</span></div>
        </div>
      </div>
    </div>
  )
}
